import {
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Input,
  ModalFooter,
  Spinner,
} from "reactstrap";
import axios from "axios";
import { useState } from "react";

const AIPromptModal = ({ modalShow, setAiPromptModal, addAIFile }) => {
  const [aiPrompt, setAiPrompt] = useState("");
  const [generatingImage, setGeneratingImage] = useState(false);
  const [generatedImage, setGeneratedImage] = useState();

  const generateAIImage = async () => {
    const BASE_URL =
      "https://ujnxu2zlyn327rcingwd2lufdm0ueppd.lambda-url.eu-west-2.on.aws";

    const newItem = {
      prompt: aiPrompt,
    };
    setGeneratingImage(true);

    try {
      setGeneratedImage(undefined);
      const data = await axios.post(`${BASE_URL}`, newItem, {});
      setGeneratingImage(false);

      setGeneratedImage(data.data.publicUrl);
    } catch (error) {
      setGeneratingImage(false);

      return error;
    }
  };

  const downloadImage = async () => {
    const response = await fetch(generatedImage);
    const blob = await response.blob();
    const imageName = generatedImage.split("/").pop();
    const downloadFile = new File([blob], imageName, {
      type: "image/png",
    });
    const toBase64 = file =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

    const base64 = await toBase64(downloadFile);

    const fileNew = {
      name: downloadFile.name,
      size: downloadFile.size,
      type: downloadFile.type,
      base64,
      file: downloadFile,
    };

    addAIFile(fileNew);

    handleClose();
  };

  const handleClose = () => {
    setAiPromptModal(false);
    setAiPrompt("");
    setGeneratedImage(undefined);
  };

  return (
    <Modal
      isOpen={modalShow}
      centered={true}
      contentClassName="ai-modal-dark"
      backdropClassName="ai-modal-backdrop"
    >
      <ModalHeader style={styles.modalHeader}>
        <div style={styles.headerRow}>
          <button
            aria-label="Close"
            onClick={handleClose}
            style={styles.closeButton}
          >
            &#10005;
          </button>
          <span style={styles.headerTitle}>Generate an Image with AI</span>
        </div>
      </ModalHeader>
      <ModalBody style={styles.modalBody}>
        {generatingImage && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 100,
              color: "#fff",
              marginTop: 50,
              background: "rgba(24,24,27,0.85)",
              zIndex: 10,
            }}
          >
            <Spinner color="secondary" size="lg" />
          </div>
        )}

        {generatedImage && (
          <div style={styles.generatedImageWrapper}>
            <img
              src={generatedImage}
              alt="Generated"
              style={styles.generatedImage}
            />
            <div style={styles.buttonRow}>
              <Button
                color="secondary"
                onClick={downloadImage}
                disabled={!generatedImage}
                style={styles.saveButton}
              >
                Save
              </Button>
              <Button
                color="secondary"
                onClick={handleClose}
                style={styles.clearButton}
              >
                Clear
              </Button>
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter style={styles.promptInputWrapper}>
        <Input
          type="textarea"
          value={aiPrompt}
          onChange={e => setAiPrompt(e.target.value)}
          placeholder="Enter your AI prompt here..."
          style={styles.promptInput}
        />
        <Button
          color="secondary"
          onClick={generateAIImage}
          style={styles.generateButton}
          disabled={!aiPrompt.length || generatingImage}
        >
          Generate
        </Button>
      </ModalFooter>
      <style>
        {`
          .ai-modal-dark {
            background: #18181b !important;
            color: #fff !important;
            border-radius: 12px;
            position: relative;
            overflow: hidden !important;
          }
          .ai-modal-backdrop {
            background: rgba(24, 24, 27, 0.95) !important;
          }
        `}
      </style>
    </Modal>
  );
};

const styles = {
  modalHeader: {
    display: "flex",
    alignItems: "center",
    background: "#18181b",
    color: "#fff",
    borderBottom: "1px solid #23232a",
    position: "relative",
    padding: "0 16px",
    height: 56,
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: 12,
    flex: 1,
  },

  closeButton: {
    background: "none",
    border: "none",
    color: "#fff",
    fontSize: 22,
    cursor: "pointer",
    marginRight: 12,
    marginLeft: 0,
    padding: "0 8px",
    lineHeight: 1,
  },
  headerTitle: {
    fontWeight: 600,
    fontSize: 18,
    flex: 1,
    textAlign: "left",
  },
  modalBody: {
    background: "#18181b",
    color: "#fff",
    minHeight: 350,
    paddingBottom: 120, // space for prompt input
    position: "relative",
  },
  generatedImageWrapper: {
    textAlign: "center",
    marginTop: 16,
  },
  generatedImage: {
    height: 200,
    width: 350,
    borderRadius: 8,
    border: "1px solid #23232a",
    background: "#23232a",
    objectFit: "cover",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "center",
    gap: 12,
    marginTop: 16,
  },
  promptInputWrapper: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    background: "#23232a",
    padding: 16,
    borderTop: "1px solid #23232a",
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  promptInput: {
    background: "#18181b",
    color: "#fff",
    paddingLeft: 8,
    height: "100%",
    border: "1px solid #333",
    resize: "none",
    minHeight: 40,
    maxHeight: 80,
  },
  generateButton: {
    minWidth: 120,
    background: "#fff",
    color: "#18181b",
    border: "1px solid #e5e5e5",
    borderRadius: 8,
  },
  saveButton: {
    minWidth: 120,
    background: "#fff",
    color: "#18181b",
    border: "1px solid #e5e5e5",
    borderRadius: 8,
  },
  clearButton: {
    borderRadius: 8,
    background: "#18181b",
    border: "1px solid #e5e5e5",
  },
};

export default AIPromptModal;
